<template>
  <HelpCenterLayout>
    <section class="bg-surface-brand-hi pb-24">
      <Title class="mx-auto max-w-full px-24 md:max-w-[1184px] md:px-32" />
    </section>

    <section
      v-if="userIsLoggedIn && userHasRecentOrder"
      class="bg-surface-brand-hi relative py-28"
    >
      <OrderLast
        class="relative z-10 mx-auto max-w-full px-24 md:max-w-[1184px] md:px-32"
      />
    </section>

    <div class="relative">
      <CurbBackground
        class="absolute top-0 -translate-y-full bg-[--rev-t107] pb-[35px] text-[--rev-t109] max-md:hidden"
      />

      <CurbBackground
        v-if="userIsLoggedIn && userHasRecentOrder"
        class="absolute bottom-0 bg-[--rev-t107] text-[--rev-t22] max-lg:hidden"
        flipped
      />
      <section
        class="py-28"
        :class="
          userIsLoggedIn && userHasRecentOrder ? '' : 'bg-surface-brand-hi'
        "
      >
        <div
          class="relative mx-auto flex max-w-full gap-32 px-24 md:max-w-[900px] md:px-32"
        >
          <LogIn v-if="!userIsLoggedIn" class="basis-1/2" />
          <FAQQuestions class="grow basis-1/2" />
          <OrdersLast
            v-if="userIsLoggedIn && userHasPreviousOrders"
            class="basis-1/2"
          />
        </div>
      </section>

      <section class="relative py-28">
        <div
          class="relative mx-auto max-w-full px-24 md:max-w-[900px] md:px-32"
        >
          <FAQSearch />
        </div>
      </section>
    </div>

    <section
      class="relative py-28"
      :class="
        userIsLoggedIn && userHasRecentOrder ? 'bg-static-default-mid' : ''
      "
    >
      <Topics
        class="relative mx-auto max-w-full px-24 md:max-w-[1184px] md:px-32"
      />
    </section>

    <section
      class="relative py-28"
      :class="
        userIsLoggedIn && userHasRecentOrder ? 'bg-static-default-mid' : ''
      "
    >
      <Reassurance
        class="mx-auto max-w-full px-24 md:max-w-[1184px] md:px-32 md:pb-72"
      />
    </section>
  </HelpCenterLayout>
</template>

<script setup lang="ts">
import CurbBackground from '~/scopes/help-center/components/CurbBackground/CurbBackground.vue'
import FAQQuestions from '~/scopes/help-center/components/FAQQuestions/FAQQuestions.vue'
import FAQSearch from '~/scopes/help-center/components/FAQSearch/FAQSearch.vue'
import LogIn from '~/scopes/help-center/components/LogIn/LogIn.vue'
import OrderLast from '~/scopes/help-center/components/OrderLast/OrderLast.vue'
import OrdersLast from '~/scopes/help-center/components/OrdersLast/OrdersLast.vue'
import Reassurance from '~/scopes/help-center/components/Reassurance/Reassurance.vue'
import Title from '~/scopes/help-center/components/Title/Title.vue'
import Topics from '~/scopes/help-center/components/Topics/Topics.vue'
import HelpCenterLayout from '~/scopes/help-center/layouts/HelpCenterLayout.vue'

const userIsLoggedIn = true
const userHasRecentOrder = true
const userHasPreviousOrders = true
</script>
